module.exports = __webpack_public_path__ + "static/media/weekly-prize.35d74c87.svg";